import React, { memo, useState } from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { Button } from '../components/ui/button'
import { USER_TYPE } from '../redux/UserRedux'
import { type TranslatorType } from '../types/FunctionTypes'
import type { ReviewType } from '../types/TherapistStateType'
import Icon from './icons/Icon'
import IconText from './icons/IconText'

type ReviewsListPropTypes = {
  reviews?: ReviewType[]
  t: TranslatorType
  userType: number
  recommendations: number
  countOfPositiveReviews: number
}

const ReviewsList: React.FC<ReviewsListPropTypes> = ({
  reviews,
  t,
  userType,
  recommendations,
  countOfPositiveReviews,
}) => {
  const [expanded, expand] = useState(false)

  const nonEmptyReviews = reviews?.filter((review) => review.text)

  const handleExpand = () => {
    expand(true)
  }

  if (!nonEmptyReviews || nonEmptyReviews.length === 0) {
    return null
  }

  return (
    <div className="mb-10">
      {/* anchor needs to be a bit higher, so the title is not under header when scrolled to */}
      <div id="reviews" className="relative -top-[80px] big-tablet:-top-[20px]" />
      <h3>{t('component.reviewList.reviewsRecommendations')}</h3>
      <div className="mb-4 flex flex-col gap-1 text-base">
        <IconText
          center
          icon={'heart-rebrand'}
          size="md"
          text={t('component.reviewList.recommendPlural', {
            count: recommendations,
          })}
        />
        <IconText
          center
          icon={'chat-rebrand'}
          size="md"
          text={t('component.reviewList.textRecommendPlural', {
            count: countOfPositiveReviews,
          })}
        />
      </div>
      {Array.isArray(nonEmptyReviews) && nonEmptyReviews.length ? (
        <ul className="list-none p-0">
          {nonEmptyReviews.slice(0, 3).map((review: ReviewType) => (
            <li key={`review-${review.id}`}>
              <div className={cn('rounded-xl bg-white p-6', 'mb-5 rounded-2xl bg-blue-500 p-5 text-base')}>
                <div className="mb-4 font-bold text-text-color">
                  <Icon icon="user-rebrand" color="secondary" className="mr-2" size="sm" />{' '}
                  {t('component.reviewList.verifiedClient')}
                </div>
                <div className="">{review.text}</div>
              </div>
            </li>
          ))}
          {nonEmptyReviews.length > 3 &&
            expanded &&
            nonEmptyReviews.slice(3).map((review: ReviewType) => (
              <li key={`review-${review.id}`}>
                <div className={cn('rounded-xl bg-white p-6', 'mb-5 rounded-2xl bg-blue-500 p-5 text-base')}>
                  <div className="mb-4 font-bold text-text-color">
                    <Icon icon="user-rebrand" color="secondary" className="mr-2" size="sm" />{' '}
                    {t('component.reviewList.verifiedClient')}
                  </div>
                  <div className="">{review.text}</div>
                </div>
              </li>
            ))}
        </ul>
      ) : (
        <span>{t(`component.reviewList.noReviews${userType === USER_TYPE.THERAPIST ? 'You' : 'Therapist'}`)}</span>
      )}
      {nonEmptyReviews.length > 3 && !expanded && (
        <div className="text-center">
          <Button onClick={handleExpand}>{t('component.reviewList.showMore')}</Button>
        </div>
      )}
    </div>
  )
}

export default memo<ReviewsListPropTypes>(ReviewsList)
